/**
 * Склейка «Город, адрес» без дубля.
 * DaData отдаёт адрес вместе с городом («г Пермь, ул Ленина, д 100»),
 * поэтому слепое `city + ', ' + address` даёт «Пермь, г Пермь, ул …».
 * Зеркало серверного bitrix_app/address_utils.py.
 */

const PLACE_PREFIXES = [
    'г', 'гор', 'город', 'п', 'пос', 'посёлок', 'поселок',
    'пгт', 'рп', 'с', 'село', 'ст', 'станица', 'д', 'деревня',
    'мкр', 'микрорайон',
];

const normToken = (value = '') => {
    let text = String(value || '').trim().toLowerCase().replace(/ё/g, 'е');
    text = text.replace(/[«»"'()]/g, '').replace(/\s+/g, ' ').replace(/^[.,\s]+|[.,\s]+$/g, '');
    if (!text) return '';
    const parts = text.split(' ');
    if (parts.length > 1 && PLACE_PREFIXES.includes(parts[0].replace(/\./g, ''))) {
        text = parts.slice(1).join(' ').trim();
    }
    return text;
};

/** Содержит ли адрес город в первых двух сегментах */
export const addressContainsCity = (address = '', city = '') => {
    const cityNorm = normToken(city);
    if (!cityNorm || !address) return false;
    const segments = String(address).split(',').map(normToken).filter(Boolean);
    return segments.slice(0, 2).includes(cityNorm);
};

/** «Город, адрес» одной строкой без дубля */
export const composeAddress = (city, address) => {
    const cityClean = String(city || '').trim();
    const addrClean = String(address || '').trim();
    if (!addrClean) return cityClean;
    if (!cityClean) return addrClean;
    if (addressContainsCity(addrClean, cityClean)) return addrClean;
    return `${cityClean}, ${addrClean}`;
};

/** Убрать город из начала адреса — для строки поиска в DaData */
export const stripCityPrefix = (address = '', city = '') => {
    const cityNorm = normToken(city);
    const raw = String(address || '').trim();
    if (!raw || !cityNorm) return raw;
    const segments = raw.split(',').map(s => s.trim()).filter(Boolean);
    while (segments.length && normToken(segments[0]) === cityNorm) segments.shift();
    return segments.join(', ');
};

/**
 * Адрес заявки для вывода. Приоритет — серверное full_address,
 * фолбэк — склейка на клиенте (старый сервер / кэш).
 */
export const applicationAddress = (application) => {
    if (!application) return '';
    if (application.full_address) return application.full_address;
    const city = application.city_name || application.custom_city_name || '';
    return composeAddress(city, application.address || '');
};